<template>
    <el-tabs type="demo-tabs">
        <el-tab-pane label="WRO世界机器人奥林匹克"><WRORobot /></el-tab-pane>
        <el-tab-pane label="FIRST机器人挑战赛"><FIRSTRobot /></el-tab-pane>
        <el-tab-pane label="F1在学校"><F1inSchools /></el-tab-pane>
    </el-tabs>
</template>

<script>
import WRORobot from "./WRORobot.vue";
import FIRSTRobot from "./FIRSTRobot.vue";
import F1inSchools from "./F1inSchools.vue";

export default {
    components: {
        WRORobot,
        FIRSTRobot,
        F1inSchools,
    },
}
</script>